// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/collectionPage.styl
// module id = 411
// module chunks = 0